import { render, staticRenderFns } from "./PageLayer.vue?vue&type=template&id=159e3326"
import script from "./PageLayer.vue?vue&type=script&lang=js"
export * from "./PageLayer.vue?vue&type=script&lang=js"
import style0 from "./PageLayer.vue?vue&type=style&index=0&id=159e3326&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports